import { State } from './types'

export const INITIAL_STATES: State = {
  currentPosition: null,
  currentPositionStatus: {
    loading: false,
  },
  searchPosition: null,
  componentRestrictions: { country: 'au' },
  view: 'list',
  stores: [],
  yourStore: null,
  components: {
    tableUI: null,
    sidebarUI: null,
    mapUI: null,
  },
  selectedStoreId: null,
}

export const AUS_STATES_FULL = {
  SA: 'South Australia',
  WA: 'Western Australia',
  VIC: 'Victoria',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  TAS: 'Tasmania',
  QLD: 'Queensland',
  ACT: 'Australian Capital Territory',
}
